@if (addsForm()) {
  <app-context-menu-item title="Add new form" popoverAppearance="dialog" [dismissGuard]="creationDismissGuard">
    <div class="box-border w-[var(--quick-form-dialog-width)]">
      <app-panel-form-create [beforeCreate]="beforeCreate" (created)="openCreated($event)" />
    </div>
  </app-context-menu-item>
}
@if (addsFolder()) {
  <app-context-menu-item title="Add new folder" popoverAppearance="dialog"
    ><div class="box-border w-[var(--quick-form-dialog-width-rail)]">
      <app-forms-quick-form
        placeholder="Untitled folder"
        [autofocus]="true"
        [createFromForm]="fileFolder"
        (close)="close()"
      /></div
  ></app-context-menu-item>
}
@if (action(); as action) {
  @if (addsForm() || addsFolder()) {
    <app-context-menu-divider />
  }
  <app-context-menu-item [title]="action.title" [close]="true" (execute)="actions.confirm(action.operation)" />
}
